import * as React from "../../_snowpack/pkg/react.js";
import {RadioGroup} from "../../_snowpack/pkg/@apsphysics/tesseract-ui-core.js";
import {getTextDegree, shouldIncludeDegreeData} from "../utils.js";
const SelectDegreeType = ({
  selectedInstitution,
  setDegree,
  nationalCounts
}) => {
  const degreeCount = (ficeCode, degreeType) => Object.entries(nationalCounts?.[degreeType] || {}).filter(([count, ficeArr]) => {
    return ficeArr.includes(ficeCode);
  })[0]?.[0];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", {
    className: "text-sm pl-2"
  }, "Select a degree program to compare with national data", /* @__PURE__ */ React.createElement("br", null), " Average Physics degrees granted (2017-2019) -", " ", selectedInstitution.name), /* @__PURE__ */ React.createElement("div", {
    className: "pl-6"
  }, /* @__PURE__ */ React.createElement(RadioGroup, {
    size: "md",
    options: ["Bachelors", "Masters", "Doctorate"].filter(shouldIncludeDegreeData(selectedInstitution)).map((degree) => ({
      label: `${getTextDegree(degree)}: ${degreeCount(selectedInstitution.ficeCode, degree) || "0"}`,
      value: degree
    })),
    orientation: "horizontal",
    name: "degree-type-radio-group",
    onChange: (e) => {
      setDegree(e.target.value);
    }
  })));
};
export default SelectDegreeType;
